import React from 'react';
import { useIntl } from 'react-intl';

/**
 * Botón que abre el historial de cambios de una fila de grilla. Va de la mano de
 * `GridHistoryModal`.
 *
 * El icono es `fa fa-history` (Font Awesome, trazo sólido) y NO `la la-history` (Line Awesome, el
 * "flaquito" que usa hoy el botón de Administración de ítems): como botón chico dentro de la
 * columna de acciones el sólido se distingue mejor del resto de los iconos. El flaquito se sigue
 * usando dentro del modal — en el header y en los badges del timeline —, donde el trazo fino es el
 * que corresponde.
 *
 * Dos formas de uso según la arquitectura de la grilla:
 *
 * 1. Grillas React/MUI — el componente:
 * ```jsx
 * <GridHistoryButton onClick={() => verHistorial(row)} />
 * ```
 *
 * 2. Grillas legacy con DataTables, donde la columna de acciones se arma como string de HTML —
 *    el helper, y después se engancha el click por la clase `historial` en el `drawCallback`:
 * ```js
 * gridHistoryButtonHtml(component.props.intl.formatMessage({ id: '…', defaultMessage: 'Historial de modificaciones' }))
 * ```
 *    OJO: el handler `.action` de esas grillas suele hacer un `setState({ redirectTo })`
 *    incondicional, así que el click del historial necesita un `return` temprano antes de ese
 *    cálculo o la acción navega.
 */

export const GRID_HISTORY_BUTTON_CLASS = 'action historial btn btn-sm btn-icon btn-dt-grid text-success';
export const GRID_HISTORY_BUTTON_ICON = 'fa fa-history fa-xs';

/** Versión string para las grillas DataTables, que construyen la celda de acciones como HTML. */
export const gridHistoryButtonHtml = (title) =>
  `<button class="${GRID_HISTORY_BUTTON_CLASS}" title="${title ? title : ''}">
      <i class="${GRID_HISTORY_BUTTON_ICON}"></i>
  </button>`;

const GridHistoryButton = (props) => {
  const intl = useIntl();

  const title = props.title
    ? props.title
    : intl.formatMessage({
        id: 'gridHistoryButton.title',
        defaultMessage: 'Historial de modificaciones',
      });

  return (
    <button
      type="button"
      className={props.className ? props.className : GRID_HISTORY_BUTTON_CLASS}
      title={title}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <i className={GRID_HISTORY_BUTTON_ICON}></i>
    </button>
  );
};

export default GridHistoryButton;
